import React from 'react';
import marble1 from '../assets/marble-1.jpg';
import marble2 from '../assets/marble-2.jpg';
import marble3 from '../assets/marble-3.jpg';

export default function Hero({ onExploreClick }) {
    return (
        <section className="hero">
            <div className="hero-content">
                <h1 className="hero-title">Luxury Marbles for Timeless Spaces</h1>
                <p className="hero-subtitle">
                    Imported & Indian Marble, Granite, and Onyx for Homes & Businesses
                </p>
                <button className="cta-button explore-btn" onClick={onExploreClick}>
                    Explore Collection
                </button>
            </div>
            <div className="hero-images">
                <div className="hero-grid">
                    <img src={marble1} alt="Luxury Interior" className="grid-img img-top-left" />
                    <img src={marble2} alt="Marble Floor" className="grid-img img-bottom-left" />
                    <img src={marble3} alt="Grand Hall" className="grid-img img-right" />
                </div>
            </div>
        </section>
    );
}
